import { Quote, Star } from "lucide-react";

interface Testimonial {
  quote: string;
  author: string;
  role: string;
  company: string;
}

const testimonials: Testimonial[] = [
  {
    quote: "Reqqy caught 12 ambiguities in our PRD that would have caused at least 3 rounds of back-and-forth with engineering.",
    author: "Sarah Chen",
    role: "Senior Product Manager",
    company: "TechFlow",
  },
  {
    quote: "We used to spend the first 20 minutes of every sprint planning clarifying requirements. Now we spend it actually planning.",
    author: "Marcus Johnson",
    role: "Engineering Lead",
    company: "DataSync",
  },
  {
    quote: "Finally, a tool that helps me write better requirements instead of just generating them. It's like having a senior PM review my work.",
    author: "Emily Rodriguez",
    role: "Associate PM",
    company: "ScaleUp",
  },
];

export function TestimonialCards() {
  return (
    <section className="py-20 md:py-32 relative overflow-hidden">
      {/* Ambient background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-primary/[0.03] blur-[140px]" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border/40 to-transparent" />

      <div className="container relative z-10 px-4 md:px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <Star className="w-4 h-4" />
            Testimonials
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
            Loved by product teams
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See why PMs and engineering leads trust Reqqy
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.author}
              className="group relative p-6 md:p-8 rounded-2xl glass border border-border/30 animate-fade-in transition-all duration-500 hover:border-primary/20 hover:shadow-[0_8px_40px_-12px_hsl(var(--primary)/0.12)]"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Hover glow */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-primary/[0.03] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="relative z-10">
                <Quote className="w-8 h-8 text-primary/20 mb-4 transition-colors duration-300 group-hover:text-primary/40" />
                <p className="text-foreground/90 mb-6 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center text-primary-foreground font-semibold text-sm transition-transform duration-300 group-hover:scale-105">
                    {testimonial.author[0]}
                  </div>
                  <div>
                    <div className="font-medium text-sm">{testimonial.author}</div>
                    <div className="text-xs text-muted-foreground">
                      {testimonial.role} at {testimonial.company}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
